const subjects = [
    {
        groupName: "Vg1",
        subjects: [
            { value: "matematikk-1t", text: "Matematikk 1T" },
            { value: "matematikk-1p", text: "Matematikk 1P" },
            { value: "naturfag", text: "Naturfag" }
        ]
    },
    {
        groupName: "Vg2",
        subjects: [
            { value: "matematikk-r1", text: "Matematikk R1" },
            { value: "matematikk-2p", text: "Matematikk 2P" },
            { value: "fysikk-1", text: "Fysikk 1" },
            { value: "kjemi-1", text: "Kjemi 1" },
            { value: "informasjonsteknologi-1", text: "Informasjonsteknologi 1" },
            { value: "teknologi-og-forskningslaere-1", text: "Teknologi og forskningslære 1" }
        ]
    },
    {
        groupName: "Vg3",
        subjects: [
            { value: "matematikk-r2", text: "Matematikk R2" },
            { value: "fysikk-2", text: "Fysikk 2" },
            { value: "kjemi-2", text: "Kjemi 2" },
            { value: "teknologi-og-forskningslaere-2", text: "Teknologi og forskningslære 2" }
        ]
    }
];

export default subjects;